import { render } from "./IREInvestmentFilter.vue?vue&type=template&id=9d314114&ts=true"
import script from "./IREInvestmentFilter.vue?vue&type=script&lang=ts"
export * from "./IREInvestmentFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__